import React from 'react';

/** Debe coincidir con el degradado del catálogo (#2D63ED → #14B39B) */
const STOP_START = '#2D63ED';
const STOP_END = '#14B39B';

/**
 * Definición única de linearGradient para iconos de acción (fill: url(#id)).
 * Colocar una vez por vista (tabla o grid); `id` debe ser estable y válido para HTML.
 */
export const CatalogActionIconGradientDefs: React.FC<{ id: string }> = ({ id }) => (
  <svg
    width={0}
    height={0}
    style={{ position: 'absolute', overflow: 'hidden' }}
    aria-hidden
    focusable="false"
  >
    <defs>
      <linearGradient id={id} x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor={STOP_START} />
        <stop offset="100%" stopColor={STOP_END} />
      </linearGradient>
    </defs>
  </svg>
);
